import { classNamesFunction, Stack, styled, Text, IconButton } from '@fluentui/react';
import { ReactNode, useCallback, useEffect } from 'react';
import { TopMenu } from '../TopMenu';
import { Sidebar } from '../Sidebar';

interface IMasterLayoutProps {
  children?: ReactNode;
  theme?: any;
  styles?: any;
}

const getStyles = ({ theme }: { theme?: any }) => {
  return {
    root: {},
    sidebar: {
    },
    contentWrapper: {}
  };
};

const getClassNames = classNamesFunction();

function MasterLayoutComponent({ children, theme, styles }: IMasterLayoutProps) {
  const classNames: any = getClassNames(styles, { theme });

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.altKey && event.key === 'ArrowUp') {
        event.preventDefault();
        scrollToTop();
      }
    };

    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [scrollToTop]);

  return (
    <>
      <TopMenu />
      <Stack horizontal className={classNames.root}>
        {/* <Stack.Item className={classNames.sidebar}
          style={{
            position: 'sticky', top: 0,
            height: '100vh', zIndex: 9999, flexShrink: 0
          }}
        >
          <Sidebar />
        </Stack.Item> */}

        {/* https://stackoverflow.com/questions/31967019/max-width-doesnt-work-in-flexbox */}
        <Stack.Item grow styles={{ root: { flexBasis: '0', minWidth: 0 } }}>
          <Stack className={classNames.contentWrapper}>
            {children}
          </Stack>
        </Stack.Item>
      </Stack>
      <Stack
        tokens={{ childrenGap: 5 }}
        styles={{
          root: {
            position: 'fixed',
            bottom: '10px',
            right: '10px',
            zIndex: 1000,
          }
        }}
      >
        <IconButton
          iconProps={{ iconName: 'Up' }}
          title="Scroll to top (Alt+Up Arrow)"
          ariaLabel="Scroll to top (Alt+Up Arrow)"
          onClick={scrollToTop}
          styles={{
            icon: {
              fontSize: '13px',

            },
            root: {
              backgroundColor: theme.palette.white,
              border: '1px solid #20202020',
              borderRadius: '50px',
            }
          }}
        />
      </Stack>

      <Text
        variant='xSmall'
        styles={{
          root: {
            color: 'gray',
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'block',
            textAlign: 'center',
            marginTop: '6px',
            position: 'fixed',
            width: '100%',
            bottom: '0',
          }
        }}
      >
        Version {process.env.REACT_APP_VERSION} / CRM {process.env.REACT_APP_CRM} / PORTAL {process.env.REACT_APP_PORTAL}
      </Text>
    </>
  );
}

export const MasterLayout = styled(MasterLayoutComponent, getStyles);
